import { render, staticRenderFns } from "./CouponsWithCode.vue?vue&type=template&id=72f67661"
import script from "./CouponsWithCode.vue?vue&type=script&lang=js"
export * from "./CouponsWithCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports